const FIELD_DEFINITIONS = [
  { key: "tail_number", label: "Tail Number" },
  { key: "priority", label: "Priority" },
  { key: "airport_identifier", label: "ICAO Location" },
  { key: "services", label: "Services" },
  { key: "contact_name", label: "Contact Name" },
  { key: "contact_role", label: "Contact Role" },
  { key: "contact_phone", label: "Contact Phone" },
  { key: "contact_email", label: "Contact Email" },
  { key: "contact_method_preference", label: "Contact Preference" },
  { key: "notes", label: "Notes" },
];

const BLANK_VALUE = "Not provided";

const normalizeValue = (value) => {
  if (Array.isArray(value)) return value.map((item) => String(item).trim()).filter(Boolean).join(", ");
  if (value === null || value === undefined) return "";
  return String(value).trim();
};

const displayValue = (value) => normalizeValue(value) || BLANK_VALUE;

export const formatBrokerChangeDiffs = (oldValues = {}, newValues = {}) =>
  FIELD_DEFINITIONS.map(({ key, label }) => {
    const before = normalizeValue(oldValues?.[key]);
    const after = normalizeValue(newValues?.[key]);
    if (before === after) return null;
    return {
      key,
      label,
      before: displayValue(oldValues?.[key]),
      after: displayValue(newValues?.[key]),
    };
  }).filter(Boolean);

export const formatBrokerChangeText = (diffs = []) =>
  diffs.map((diff) => `${diff.label}: ${diff.before} -> ${diff.after}`).join("\n");

export const formatBrokerChangeSummary = (diffs = [], maxLabels = 4) => {
  if (!diffs.length) return "";
  const visible = diffs.slice(0, maxLabels).map((diff) => diff.label);
  const remaining = diffs.length - visible.length;
  return `Changed: ${visible.join(", ")}${remaining > 0 ? `, +${remaining} more` : ""}.`;
};
